<template>
    <div>
        <select-input :options="meta.forms" v-model="selectedForm" class="w-full" />
                        
        <div v-if="selectedForm">
            <div class="my-4"></div>

            <label>{{ __('Fields') }}</label>
            <div class="help-block">
                <p>{{ __('Here you can configure user-defined display texts, placeholders or default values that will be displayed in the selected form.') }} <a :href="blueprintUrl">{{ __('Edit Blueprint') }}</a></p>
            </div>

            <div class="flex replicator-set shadow-sm border rounded bg-grey-200 grid-stacked p-4 mt-4 mb-4" v-for="(field, index) in currentForm.fields" :key="index">
                <div class="w-full">

                    <!-- Selection of the field (e.g. Name, E-Mail, etc.) -->
                    <label>{{ __('Field') }}</label>
                    <select-input :options="getSelectableFormFields(field.handle)" v-model="field.handle" class="w-full mb-4" :isReadOnly="!field.handle" @input="updateFieldOptions(field, true)" />
                    
                    <!-- Special configuration setup for checkboxes, radios and selects -->
                    <div v-if="['checkbox', 'radio', 'select'].includes(getInputType(field.handle))">

                        <div class="mb-4">
                            <label>{{ __('Display text') }}</label>
                            <text-input v-model="field.label" />
                        </div>

                        <div v-if="getInputType(field.handle) == 'select'" class="mb-4">
                            <label>{{ __('Placeholder') }}</label>
                            <text-input v-model="field.placeholder" />
                        </div>

                        <label>{{ __('Options') }}</label>
                        <div class="flex items-center mb-4" v-for="(text, key) in field.options" :key="key">
                            <input :type="getInputType(field.handle)"
                                :value="key"
                                :name="getInputType(field.handle) == 'radio' ? field.handle : field.handle + '[]'"
                                v-model="field.default"
                                v-if="getInputType(field.handle) !== 'select'"
                            />
                            <text-input v-model="field.options[key]" class="ml-2 w-full" />
                        </div>
                    </div>

                    <!-- Default configuration setup -->
                    <div class="grid grid-cols-2 w-full" v-else-if="field.handle">
                        <div class="col-span-2 mb-4">
                            <label>{{ __('Display text') }}</label>
                            <text-input v-model="field.label" />
                        </div>
                        <div class="mb-4">
                            <label>{{ __('Hint') }} ({{ __('Inside field') }})</label>
                            <text-input v-model="field.placeholder" />
                        </div>
                        <div class="mb-4">
                            <label>{{ __('Default Value') }} ({{ __('Inside field') }})</label>
                            <text-input v-model="field.default" />
                        </div>
                    </div>
                </div>
                <a @click="deleteItem(currentForm.fields, index)" class="ml-4 inline opacity-50 text-2xl antialiased hover:opacity-75">&times;</a>
            </div>
            <button class="btn" v-text="__('Add Field')" @click.prevent="currentForm.fields.push({ handle: 'abc'})" />

        </div>

    </div>
</template>

<style scoped>
    label {
        margin-bottom: 0.5rem;
    }
</style>
 
<script>
export default {
    mixins: [Fieldtype],

    data() {
        return {
            selectedForm: null,
            formConfigs: this.value
        }
    },

    mounted() {
        // if there is only one form, select it
        if (this.meta.forms.length == 1)
            Vue.set(this, 'selectedForm', this.meta.forms[0].value);
    },

    computed: {
        currentForm() {
            return this.formConfigs[this.selectedForm];
        },
        blueprintUrl() {
            return cp_url(`/forms/${this.selectedForm}/blueprint`);
        }
    },

    methods: {

        getSelectableFormFields(whitelistedItem) {
            return this.meta.fields[this.selectedForm].filter((formField) => {
                return !this.currentForm.fields.some((f) => {
                    return f.handle == formField.value & f.handle !== whitelistedItem;
                });
            });
        },

        getField(fieldHandle) {
            return this.meta.fields[this.selectedForm].find(f => f.value == fieldHandle) ?? {};
        },

        getInputType(fieldHandle) {
            const type = this.getField(fieldHandle)?.type;
            switch (type) {
                case 'checkboxes':
                    return 'checkbox';
                case 'radio':
                case 'select':
                    return type;
                default:
                    return 'text';
            }
        },

        updateFieldOptions(field) {
            let blueprintField = this.getField(field.handle);
            let options = {};
            for (const [key, value] of Object.entries(blueprintField.options ?? {})) {
                let originalOptions = field.options;
                options[key] = (originalOptions ? originalOptions[key] : null) ?? value;
            }

             if (this.getInputType(field.handle) == 'checkbox') {
                if (!field.default)
                    field.default = [];

                if (!Array.isArray(field.default))
                    field.default = [field.default];
            }

            field.options = options;

            Vue.set(field, 'options', options);
        },

        deleteItem(array, index) {
            array.splice(index, 1);
        },

    },

    watch: {
        formConfigs: {
            deep: true,
            handler (forms) {
                this.updateDebounced(forms);
            }
        }
    }
};
</script>